import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
// import LogoImg from "../../../static/i/newtelecom-logo-800.png"
import OGImg from "../../../static/i/internet-newtelecom.jpg"

const SEO = ({ title, description, image, url, lang, noindex }) => {
  const link = "https://newtelecom.ua"
  image = image ? image : link + OGImg

  return (
    <Helmet>
      <html amp lang={lang} />
      {/* General tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="image" content={image} />
      <link rel="canonical" href={`${link}${url}`} />

      {noindex === "noindex" ? <meta name="robots" content="noindex" /> : ``}

      {/* OpenGraph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${link}${url}`} />
      <meta property="og:locale" content={lang} />
      <meta property="og:locale:alternate" content={lang} />
      <meta property="og:site_name" content="Новий Телеком (Newtelecom)" />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="620" />
      <meta property="og:image:height" content="460" />
      <meta property="fb:app_id" content="276694743965863" />

      {/* Twitter Card tags */}
      {/* <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@AccoutNameHere" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} /> */}
      {/* https://github.com/nfl/react-helmet */}

      {/* org scheme */}
      {/* <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "LegalService",
          "@id": "${link}",
          "name": "Центр Ліцензій",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Pidlisna St, 1, 8",
            "addressLocality": "Kyiv",
            "addressRegion": "Kyiv",
            "postalCode": "03164",
            "addressCountry": "UK"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 50.4720894,
            "longitude": 30.3374664
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "ratingCount": "20"
          },
          "url": "https://лицензии.укр/kontakty/",
          "telephone": "+380683328808",
          "priceRange": "$",
          "logo": "${link + LogoImg}",
          "image": [
            "${link + OGImg}"
          ],
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday"
              ],
              "opens": "10:00",
              "closes": "18:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Saturday",
              "opens": "10:00",
              "closes": "16:00"
            }
          ]
        }
      `}</script> */}
    </Helmet>
  )
}

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  lang: PropTypes.string,
}
SEO.defaultProps = {
  title: "Новий Телеком",
  description: "Інтернет провайдер Новий Телеком",
  image: null,
  url: null,
  lang: "uk",
}

export default SEO
